module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "certificado-editor"
  }, [(_vm.pageLoading === true) ? _c('div', {
    attrs: {
      "id": "page-loading"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-5x fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("Aguarde um momento")])]) : _vm._e(), _vm._v(" "), (_vm.certificadoDados) ? _c('div', {
    staticClass: "row-flex"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(_vm.id === '0') ? _c('h2', {
    staticClass: "vp-h2 vp-module-heading"
  }, [_vm._v("\n        Novo certificado\n      ")]) : _c('h2', {
    staticClass: "vp-h2 vp-module-heading"
  }, [_vm._v("\n        Editar certificado: "), _c('span', {
    staticStyle: {
      "text-transform": "none",
      "margin-right": "20px"
    }
  }, [_vm._v(_vm._s(_vm.certificadoDados.nome))]), _vm._v(" "), (_vm.certificadoDados.ativo === '0' && _vm.activateFlag === false) ? _c('small', {
    staticClass: "n-ativo"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-times-circle-o"
  }), _vm._v("Não ativo\n          "), _c('a', {
    staticClass: "btn btn-sm",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.handleCertificateStatus()
      }
    }
  }, [_vm._v("Ativar")])]) : _vm._e(), _vm._v(" "), (_vm.certificadoDados.ativo === '1' && _vm.activateFlag === true) ? _c('small', {
    staticClass: "n-ativo"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check-circle-o"
  }), _vm._v("Ativação em espera "), _c('small', [_vm._v("(Salve o certificado para confirmar)")])]) : _vm._e(), _vm._v(" "), (_vm.certificadoDados.ativo === '1' && _vm.activateFlag === false) ? _c('small', {
    staticClass: "ativo"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check-circle"
  }), _vm._v("Ativo\n          "), _c('a', {
    staticClass: "btn btn-sm",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.handleCertificateStatus()
      }
    }
  }, [_vm._v("Desativar")])]) : _vm._e(), _vm._v(" "), (_vm.certificadoDados.ativo === '0' && _vm.activateFlag === true) ? _c('small', {
    staticClass: "ativo"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check-circle-o"
  }), _vm._v("Desativação em espera "), _c('small', [_vm._v("(Salve o certificado para confirmar)")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitCertificateData()
      }
    }
  }, [_c('div', {
    staticClass: "form-group row-flex"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-12  small-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.nome),
      expression: "certificadoDados.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": 'campo_' + _vm.certificadoDados.id,
      "placeholder": "Escolha um nome para identificar o certificado"
    },
    domProps: {
      "value": (_vm.certificadoDados.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.certificadoDados, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Máximo de 45 caracteres)")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row-flex"
  }, [_c('label', {
    staticClass: "col-12 control-label"
  }, [_vm._v("\n            Tipo de certificado:\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12  small-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.tipo),
      expression: "certificadoDados.tipo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": 'campo_' + _vm.certificadoDados.id
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.certificadoDados, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "evento"
    }
  }, [_vm._v("Certificado do evento")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "trabalho"
    }
  }, [_vm._v("Certificado de trabalho")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "atividade"
    },
    domProps: {
      "selected": _vm.id == '0' && _vm.activeEventCertificate != '0'
    }
  }, [_vm._v("Certificado de uma atividade")])]), _vm._v(" "), (_vm.certificadoDados.tipo === 'evento' && _vm.id != _vm.activeEventCertificate && _vm.activeEventCertificate != '0') ? _c('small', {
    staticClass: "attention"
  }, [_vm._v("Um outro certificado já está sendo utilizado como certificado deste evento"), (_vm.id === '0') ? _c('span', [_vm._v("."), _c('br'), _vm._v("Se você criar um novo certificado de evento, o anterior será DESABILITADO e o novo ficará ativo e disponível aos participantes")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row-flex"
  }, [_c('label', {
    staticClass: "col-12 control-label"
  }, [_vm._v("\n            Formato do certificado:\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 small-6"
  }, [_c('div', {
    staticClass: "row-flex"
  }, [_c('span', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.configs.formato),
      expression: "certificadoDados.configs.formato"
    }],
    attrs: {
      "type": "radio",
      "name": "formato",
      "id": "formato_paisagem",
      "value": "paisagem"
    },
    domProps: {
      "checked": _vm._q(_vm.certificadoDados.configs.formato, "paisagem")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.certificadoDados.configs, "formato", "paisagem")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "formato_paisagem"
    }
  }, [_vm._v("\n                  Paisagem\n                ")])]), _vm._v(" "), _c('span', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.configs.formato),
      expression: "certificadoDados.configs.formato"
    }],
    attrs: {
      "type": "radio",
      "name": "formato",
      "id": "formato_retrato",
      "value": "retrato"
    },
    domProps: {
      "checked": _vm._q(_vm.certificadoDados.configs.formato, "retrato")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.certificadoDados.configs, "formato", "retrato")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "formato_retrato"
    }
  }, [_vm._v("\n                  Retrato\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row-flex"
  }, [_c('label', {
    staticClass: "col-12 control-label"
  }, [_vm._v("\n            Certificado sem margem?\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12  small-6"
  }, [_c('div', {
    staticClass: "row-flex"
  }, [_c('span', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.configs.use_margin),
      expression: "certificadoDados.configs.use_margin"
    }],
    attrs: {
      "type": "radio",
      "name": "use_margin",
      "id": "use_margin_0",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.certificadoDados.configs.use_margin, "0")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.certificadoDados.configs, "use_margin", "0")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "use_margin_0"
    }
  }, [_vm._v("Sim")])]), _vm._v(" "), _c('span', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.configs.use_margin),
      expression: "certificadoDados.configs.use_margin"
    }],
    attrs: {
      "type": "radio",
      "name": "use_margin",
      "id": "use_margin_1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.certificadoDados.configs.use_margin, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.certificadoDados.configs, "use_margin", "1")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "use_margin_1"
    }
  }, [_vm._v("Não")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row-flex cert-tab-content"
  }, [_c('ul', {
    staticClass: "control-tabs",
    class: {
      'scrolled': _vm.scrolled
    }
  }, [_c('li', {
    class: {
      'active': _vm.activeTab === 'text'
    }
  }, [_c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: ({
        content: '<strong>Texto do certificado</strong>',
        classes: 'tab-tooltip'
      }),
      expression: "{content: '<strong>Texto do certificado</strong>', classes: 'tab-tooltip'}",
      modifiers: {
        "bottom": true
      }
    }],
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changeTab('text')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-font"
  }), _vm._v(" "), _c('span', [_vm._v("Texto do certificado")])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasVerso()),
      expression: "hasVerso()"
    }],
    class: {
      'active': _vm.activeTab === 'text_verso'
    }
  }, [_c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: ({
        content: '<strong>Texto do verso do certificado</strong>',
        classes: 'tab-tooltip'
      }),
      expression: "{content: '<strong>Texto do verso do certificado</strong>', classes: 'tab-tooltip'}",
      modifiers: {
        "bottom": true
      }
    }],
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changeTab('text_verso')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-undo"
  }), _vm._v(" "), _c('span', [_vm._v("Texto do verso")])])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.activeTab === 'background'
    }
  }, [_c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: ({
        content: '<strong>Imagem de fundo</strong>',
        classes: 'tab-tooltip'
      }),
      expression: "{content: '<strong>Imagem de fundo</strong>', classes: 'tab-tooltip'}",
      modifiers: {
        "bottom": true
      }
    }],
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changeTab('background')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-image"
  }), _vm._v(" "), _c('span', [_vm._v("Imagem de fundo")])])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.activeTab === 'signatures'
    }
  }, [_c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: ({
        content: '<strong>Assinaturas</strong>',
        classes: 'tab-tooltip'
      }),
      expression: "{content: '<strong>Assinaturas</strong>', classes: 'tab-tooltip'}",
      modifiers: {
        "bottom": true
      }
    }],
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changeTab('signatures')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pencil"
  }), _vm._v(" "), _c('span', [_vm._v("Assinaturas")])])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.activeTab === 'general'
    }
  }, [_c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: ({
        content: '<strong>Configurações</strong>',
        classes: 'tab-tooltip'
      }),
      expression: "{content: '<strong>Configurações</strong>', classes: 'tab-tooltip'}",
      modifiers: {
        "bottom": true
      }
    }],
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changeTab('general')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cogs"
  }), _vm._v(" "), _c('span', [_vm._v("Configurações")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'text' || _vm.activeTab === 'text_verso'),
      expression: "activeTab==='text' || activeTab==='text_verso'"
    }],
    staticClass: "text col-12"
  }, [(_vm.activeTab === 'text') ? _c('h4', {
    staticClass: "vp-h4 tab-title"
  }, [_vm._v("Texto do certificado")]) : (_vm.activeTab === 'text_verso') ? _c('h4', {
    staticClass: "vp-h4 tab-title"
  }, [_vm._v("Texto do verso")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row-flex"
  }, [_c('div', {
    staticClass: "col-12 small-6"
  }, [_c('div', {
    staticClass: "form-group row-flex"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'text_verso'),
      expression: "activeTab=='text_verso'"
    }]
  }, [_vm._v(_vm._s(_vm.certificadoDados.tipo === 'evento' ? 'Participante com Atividades' : 'Verso do certificado'))]), _vm._v(" "), _c('tinymce', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "editorUm",
      "content": _vm.editorContent.um,
      "options": _vm.options
    },
    model: {
      value: (_vm.editor.um),
      callback: function($$v) {
        _vm.$set(_vm.editor, "um", $$v)
      },
      expression: "editor.um"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'text_verso'),
      expression: "activeTab=='text_verso'"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.certificadoDados.tipo === 'evento'),
      expression: "certificadoDados.tipo==='evento'"
    }]
  }, [_c('h3', [_vm._v("Participante sem Atividades")]), _vm._v(" "), _c('tinymce', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "editorDois",
      "content": _vm.editorContent.dois,
      "options": _vm.options
    },
    model: {
      value: (_vm.editor.dois),
      callback: function($$v) {
        _vm.$set(_vm.editor, "dois", $$v)
      },
      expression: "editor.dois"
    }
  })], 1), _vm._v(" "), _c('h3', [_vm._v("Rodapé do verso")]), _vm._v(" "), _c('tinymce', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "editorTres",
      "content": _vm.editorContent.tres,
      "options": _vm.options
    },
    model: {
      value: (_vm.editor.tres),
      callback: function($$v) {
        _vm.$set(_vm.editor, "tres", $$v)
      },
      expression: "editor.tres"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.activeTab === 'text') ? _c('div', {
    staticClass: "form-group row-flex"
  }, [_c('label', {
    staticClass: "col-12 control-label"
  }, [_vm._v("\n                    Cor do texto no certificado:\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('compact-picker', {
    model: {
      value: (_vm.certificadoDados.configs.textoColor),
      callback: function($$v) {
        _vm.$set(_vm.certificadoDados.configs, "textoColor", $$v)
      },
      expression: "certificadoDados.configs.textoColor"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.configs.textoColor.hex),
      expression: "certificadoDados.configs.textoColor.hex"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cor-texto",
      "placeholder": "Insira a cor do texto em hexadecimal",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.certificadoDados.configs.textoColor.hex)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.certificadoDados.configs.textoColor, "hex", $event.target.value)
      }
    }
  })], 1)]) : (_vm.activeTab === 'text_verso') ? _c('div', {
    staticClass: "form-group row-flex"
  }, [_c('a', {
    staticClass: "btn vp-btn vp-action-btn",
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.padraoVerso()
      }
    }
  }, [_vm._v("Restaurar padrão no verso")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-12 small-6 tables"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "vp-flextable alternate"
  }, [_vm._m(2, false, false), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), _vm._m(4, false, false), _vm._v(" "), _vm._m(5, false, false), _vm._v(" "), _vm._m(6, false, false), _vm._v(" "), _vm._m(7, false, false), _vm._v(" "), _vm._l((_vm.camposForm), function(campo) {
    return (campo.nome !== 'senha') ? _c('div', {
      staticClass: "vp-ft-row closeable",
      class: {
        'expand': _vm.openMoreTags
      }
    }, [_c('div', {
      staticClass: "vp-ft-col"
    }, [_vm._v("\n                      " + _vm._s('{' + campo.titulo_r + '}') + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "vp-ft-col"
    }, [_vm._v("\n                      Irá exibir o campo "), _c('strong', [_vm._v(_vm._s(campo.titulo))]), _vm._v(" do formulário\n                    ")])]) : _vm._e()
  }), _vm._v(" "), _c('a', {
    staticClass: "open-more-tags-btn",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.openMoreTags = !_vm.openMoreTags
      }
    }
  }, [(_vm.openMoreTags) ? _c('i', {
    staticClass: "fa fa-angle-double-up"
  }) : _vm._e(), _vm._v("\n                    " + _vm._s((_vm.openMoreTags ? 'Fechar' : 'Ver mais')) + "\n                    "), (!_vm.openMoreTags) ? _c('i', {
    staticClass: "fa fa-angle-double-down"
  }) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "vp-flextable alternate"
  }, [_vm._m(8, false, false), _vm._v(" "), _vm._m(9, false, false), _vm._v(" "), _vm._m(10, false, false), _vm._v(" "), (_vm.certificadoDados.tipo === 'atividade') ? _c('div', {
    staticClass: "vp-ft-row"
  }, [_c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      {lista atividades}\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      Lista os nomes de todas as atividades\n                    ")])]) : _c('div', {
    staticClass: "vp-ft-row"
  }, [_c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      {listaAtividades}\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      Lista os nomes de todas as atividades\n                    ")])]), _vm._v(" "), (_vm.certificadoDados.tipo === 'atividade') ? _c('div', {
    staticClass: "vp-ft-row"
  }, [_c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      {horas atividade}\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      Quantidade de horas da atividade do certificado\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.certificadoDados.tipo === 'atividade') ? _c('div', {
    staticClass: "vp-ft-row"
  }, [_c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      {nome atividade}\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      Nome da atividade do certificado\n                    ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "vp-flextable alternate"
  }, [_vm._m(11, false, false), _vm._v(" "), _vm._l((_vm.trabalhoForm), function(campo) {
    return (campo.nome !== 'senha') ? _c('div', {
      staticClass: "vp-ft-row"
    }, [_c('div', {
      staticClass: "vp-ft-col"
    }, [_vm._v("\n                      " + _vm._s('{' + campo.titulo + '}') + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "vp-ft-col"
    }, [_vm._v("\n                      Irá exibir o campo "), _c('strong', [_vm._v(_vm._s(campo.titulo))]), _vm._v(" do formulário\n                    ")])]) : _vm._e()
  })], 2)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'background'),
      expression: "activeTab==='background'"
    }],
    staticClass: "background col-12"
  }, [_c('h4', {
    staticClass: "vp-h4 tab-title"
  }, [_vm._v("Imagem de fundo do certificado")]), _vm._v(" "), _c('div', {
    staticClass: "row-flex"
  }, [_vm._l((_vm.models), function(model) {
    return _c('div', {
      staticClass: "col-6 small-6 mid-4 big-3 background-item"
    }, [(model.id != 0) ? _c('a', {
      staticClass: "btn vp-delete-btn vp-btn btn-sm remove-btn",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.removeModel(model.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-times"
    })]) : _vm._e(), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'modelo_' + model.id
      }
    }, [_c('div', {
      staticClass: "bg-item-wrapper"
    }, [_c('img', {
      attrs: {
        "src": model.link ? _vm.url + model.link : undefined
      }
    }), _vm._v(" "), _c('table', [_c('tr', [_c('td', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.bottom",
        value: ({
          content: '<strong>Imagem de fundo da capa</strong>',
          classes: 'tab-tooltip'
        }),
        expression: "{content: '<strong>Imagem de fundo da capa</strong>', classes: 'tab-tooltip'}",
        modifiers: {
          "bottom": true
        }
      }],
      class: {
        'active-model': _vm.certificadoDados.modelo_id == model.id
      },
      staticStyle: {
        "max-width": "20px"
      },
      on: {
        "click": function($event) {
          _vm.certificadoDados.modelo_id = model.id
        }
      }
    }, [_vm._m(12, true, false)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model.nome))]), _vm._v(" "), (_vm.hasVerso()) ? _c('td', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.bottom",
        value: ({
          content: '<strong>Imagem de fundo do verso</strong>',
          classes: 'tab-tooltip'
        }),
        expression: "{content: '<strong>Imagem de fundo do verso</strong>', classes: 'tab-tooltip'}",
        modifiers: {
          "bottom": true
        }
      }],
      class: {
        'active-model': _vm.certificadoDados.modelo_verso_id == model.id
      },
      staticStyle: {
        "max-width": "20px"
      },
      on: {
        "click": function($event) {
          _vm.certificadoDados.modelo_verso_id = model.id
        }
      }
    }, [_vm._m(13, true, false)]) : _vm._e()])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-6 small-6 mid-4 big-3 background-item"
  }, [_c('a', {
    staticClass: "new-image-button",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showNewModelModal = !_vm.showNewModelModal
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus-circle"
  }), _vm._v("Adicionar novo modelo")])])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'signatures'),
      expression: "activeTab==='signatures'"
    }],
    staticClass: "signatures col-12"
  }, [_c('h4', {
    staticClass: "vp-h4 tab-title"
  }, [_vm._v("Assinaturas")]), _vm._v(" "), _c('div', {
    staticClass: "row-flex"
  }, [_vm._l((_vm.signatures), function(sign) {
    return _c('div', {
      staticClass: "col-6 small-6 mid-4 big-3 signature-item"
    }, [_c('a', {
      staticClass: "btn vp-delete-btn vp-btn btn-sm remove-btn",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.removeSignature(sign.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-times"
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.certificadoDados.configs.assinaturas),
        expression: "certificadoDados.configs.assinaturas"
      }],
      attrs: {
        "type": "checkbox",
        "name": "assinaturas[]",
        "id": 'assinatura_' + sign.id
      },
      domProps: {
        "value": sign.id,
        "checked": Array.isArray(_vm.certificadoDados.configs.assinaturas) ? _vm._i(_vm.certificadoDados.configs.assinaturas, sign.id) > -1 : (_vm.certificadoDados.configs.assinaturas)
      },
      on: {
        "click": function($event) {
          _vm.handleSignatureLinks(sign)
        },
        "change": function($event) {
          var $$a = _vm.certificadoDados.configs.assinaturas,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = sign.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.certificadoDados.configs.assinaturas = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.certificadoDados.configs.assinaturas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.certificadoDados.configs, "assinaturas", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'assinatura_' + sign.id
      }
    }, [_c('div', {
      staticClass: "sg-item-wrapper",
      class: {
        'active': _vm.isInListOfSigns(sign.id)
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.url + sign.link
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(sign.nome))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-6 small-6 mid-4 big-3 signature-item"
  }, [_c('a', {
    staticClass: "new-image-button",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showNewSignatureModal = !_vm.showNewSignatureModal
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus-circle"
  }), _vm._v("Adicionar nova assinatura")])])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'general'),
      expression: "activeTab==='general'"
    }],
    staticClass: "general col-12"
  }, [_c('h4', {
    staticClass: "vp-h4 tab-title"
  }, [_vm._v("Configurações gerais")]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row-flex"
  }, [_c('label', {
    staticClass: "col-12 small-8 control-label"
  }, [_vm._v("\n                  Exibir verso do certificado?\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 small-4"
  }, [_c('div', {
    staticClass: "row-flex"
  }, [_c('span', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.configs.atividades_verso),
      expression: "certificadoDados.configs.atividades_verso"
    }],
    attrs: {
      "type": "radio",
      "name": "atividades_verso",
      "id": "atividades_verso_1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.certificadoDados.configs.atividades_verso, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.certificadoDados.configs, "atividades_verso", "1")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "atividades_verso_1"
    }
  }, [_vm._v("Sim")])]), _vm._v(" "), _c('span', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.configs.atividades_verso),
      expression: "certificadoDados.configs.atividades_verso"
    }],
    attrs: {
      "type": "radio",
      "name": "atividades_verso",
      "id": "atividades_verso_0",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.certificadoDados.configs.atividades_verso, "0")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.certificadoDados.configs, "atividades_verso", "0")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "atividades_verso_0"
    }
  }, [_vm._v("Não")])])])])]), _vm._v(" "), _c('h4', [_vm._v("Link de autenticação no rodapé")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row-flex"
  }, [_c('label', {
    staticClass: "col-12 control-label"
  }, [_vm._v("\n                  Cor do texto:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('compact-picker', {
    model: {
      value: (_vm.certificadoDados.configs.link_autenticacao.cor),
      callback: function($$v) {
        _vm.$set(_vm.certificadoDados.configs.link_autenticacao, "cor", $$v)
      },
      expression: "certificadoDados.configs.link_autenticacao.cor"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.configs.link_autenticacao.cor.hex),
      expression: "certificadoDados.configs.link_autenticacao.cor.hex"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": 'campo_' + _vm.certificadoDados.id,
      "placeholder": "Insira um valor hexadecimal de cor. Ex.:'#000000'",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.certificadoDados.configs.link_autenticacao.cor.hex)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.certificadoDados.configs.link_autenticacao.cor, "hex", $event.target.value)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row-flex"
  }, [_c('label', {
    staticClass: "col-12 control-label"
  }, [_vm._v("\n                  Posição do texto do rodapé:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row-flex"
  }, [_c('span', {
    staticClass: "col-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.configs.link_autenticacao.posicao),
      expression: "certificadoDados.configs.link_autenticacao.posicao"
    }],
    attrs: {
      "type": "radio",
      "name": "pos_link",
      "id": "pos_esquerda",
      "value": "esquerda"
    },
    domProps: {
      "checked": _vm._q(_vm.certificadoDados.configs.link_autenticacao.posicao, "esquerda")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.certificadoDados.configs.link_autenticacao, "posicao", "esquerda")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "pos_esquerda"
    }
  }, [_vm._v("Esquerda")])]), _vm._v(" "), _c('span', {
    staticClass: "col-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.configs.link_autenticacao.posicao),
      expression: "certificadoDados.configs.link_autenticacao.posicao"
    }],
    attrs: {
      "type": "radio",
      "name": "pos_link",
      "id": "pos_centro",
      "value": "centro"
    },
    domProps: {
      "checked": _vm._q(_vm.certificadoDados.configs.link_autenticacao.posicao, "centro")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.certificadoDados.configs.link_autenticacao, "posicao", "centro")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "pos_centro"
    }
  }, [_vm._v("Centro")])]), _vm._v(" "), _c('span', {
    staticClass: "col-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.configs.link_autenticacao.posicao),
      expression: "certificadoDados.configs.link_autenticacao.posicao"
    }],
    attrs: {
      "type": "radio",
      "name": "pos_link",
      "id": "pos_direita",
      "value": "direita"
    },
    domProps: {
      "checked": _vm._q(_vm.certificadoDados.configs.link_autenticacao.posicao, "direita")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.certificadoDados.configs.link_autenticacao, "posicao", "direita")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "pos_direita"
    }
  }, [_vm._v("Direita")])])])])])]), _vm._v(" "), (_vm.certificadoDados.tipo === 'evento') ? _c('fieldset', [_c('h4', [_vm._v("Condições para o participante obter certificado do evento")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row-flex"
  }, [_c('label', {
    staticClass: "col-12 small-8 control-label"
  }, [_vm._v("\n                  Obrigar presença do participante no evento\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 small-4"
  }, [_c('div', {
    staticClass: "row-flex"
  }, [_c('span', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.configs.evento_conditions.obrigar_presenca),
      expression: "certificadoDados.configs.evento_conditions.obrigar_presenca"
    }],
    attrs: {
      "type": "radio",
      "name": "obrigar_presenca",
      "id": "obrigar_presenca_1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.certificadoDados.configs.evento_conditions.obrigar_presenca, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.certificadoDados.configs.evento_conditions, "obrigar_presenca", "1")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "obrigar_presenca_1"
    }
  }, [_vm._v("Sim")])]), _vm._v(" "), _c('span', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.configs.evento_conditions.obrigar_presenca),
      expression: "certificadoDados.configs.evento_conditions.obrigar_presenca"
    }],
    attrs: {
      "type": "radio",
      "name": "obrigar_presenca",
      "id": "obrigar_presenca_0",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.certificadoDados.configs.evento_conditions.obrigar_presenca, "0")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.certificadoDados.configs.evento_conditions, "obrigar_presenca", "0")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "obrigar_presenca_0"
    }
  }, [_vm._v("Não")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row-flex"
  }, [_c('label', {
    staticClass: "col-12 small-8 control-label"
  }, [_vm._v("\n                  Obrigar preenchimento de feedback\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 small-4"
  }, [_c('div', {
    staticClass: "row-flex"
  }, [_c('span', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.configs.evento_conditions.obrigar_feedback),
      expression: "certificadoDados.configs.evento_conditions.obrigar_feedback"
    }],
    attrs: {
      "type": "radio",
      "name": "obrigar_feedback",
      "id": "obrigar_feedback_1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.certificadoDados.configs.evento_conditions.obrigar_feedback, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.certificadoDados.configs.evento_conditions, "obrigar_feedback", "1")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "obrigar_feedback_1"
    }
  }, [_vm._v("Sim")])]), _vm._v(" "), _c('span', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.configs.evento_conditions.obrigar_feedback),
      expression: "certificadoDados.configs.evento_conditions.obrigar_feedback"
    }],
    attrs: {
      "type": "radio",
      "name": "obrigar_feedback",
      "id": "obrigar_feedback_0",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.certificadoDados.configs.evento_conditions.obrigar_feedback, "0")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.certificadoDados.configs.evento_conditions, "obrigar_feedback", "0")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "obrigar_feedback_0"
    }
  }, [_vm._v("Não")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row-flex"
  }, [_c('label', {
    staticClass: "col-12 small-8 control-label"
  }, [_vm._v("\n                  Obrigar presença mínima nas atividades\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 small-4"
  }, [_c('div', {
    staticClass: "row-flex"
  }, [_c('span', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.configs.evento_conditions.obrigar_presenca_minima_atividades),
      expression: "certificadoDados.configs.evento_conditions.obrigar_presenca_minima_atividades"
    }],
    attrs: {
      "type": "radio",
      "name": "obrigar_presenca_minima_atividades",
      "id": "obrigar_presenca_minima_atividades_1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.certificadoDados.configs.evento_conditions.obrigar_presenca_minima_atividades, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.certificadoDados.configs.evento_conditions, "obrigar_presenca_minima_atividades", "1")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "obrigar_presenca_minima_atividades_1"
    }
  }, [_vm._v("Sim")])]), _vm._v(" "), _c('span', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.configs.evento_conditions.obrigar_presenca_minima_atividades),
      expression: "certificadoDados.configs.evento_conditions.obrigar_presenca_minima_atividades"
    }],
    attrs: {
      "type": "radio",
      "name": "obrigar_presenca_minima_atividades",
      "id": "obrigar_presenca_minima_atividades_0",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.certificadoDados.configs.evento_conditions.obrigar_presenca_minima_atividades, "0")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.certificadoDados.configs.evento_conditions, "obrigar_presenca_minima_atividades", "0")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "obrigar_presenca_minima_atividades_0"
    }
  }, [_vm._v("Não")])])])])]), _vm._v(" "), (_vm.certificadoDados.configs.evento_conditions.obrigar_presenca_minima_atividades === '1') ? _c('div', {
    staticClass: "form-group row-flex"
  }, [_c('label', {
    staticClass: "col-12 small-8 control-label"
  }, [_vm._v("\n                  Quantos minutos totais o participante deverá ter, somando a presença em todas as atividades?\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 small-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certificadoDados.configs.evento_conditions.minutos_presenca_minima_atividades),
      expression: "certificadoDados.configs.evento_conditions.minutos_presenca_minima_atividades"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "minutos_presenca_minima_atividades",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.certificadoDados.configs.evento_conditions.minutos_presenca_minima_atividades)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.certificadoDados.configs.evento_conditions, "minutos_presenca_minima_atividades", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(14, false, false)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.certificadoDados.tipo === 'atividade') ? _c('fieldset', {
    staticClass: "activity-list"
  }, [_c('h4', [_vm._v("Atividades que utilizarão este certificado")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row-flex"
  }, [_vm._l((_vm.activitiesOptions), function(atividade) {
    return _c('div', {
      staticClass: "col-12 small-6"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.activitiesSelected),
        expression: "activitiesSelected"
      }],
      attrs: {
        "type": "checkbox",
        "name": "atividades[]",
        "id": 'atividade-' + atividade.id
      },
      domProps: {
        "value": atividade.id,
        "checked": atividade.certificado === _vm.certificadoDados.id,
        "checked": Array.isArray(_vm.activitiesSelected) ? _vm._i(_vm.activitiesSelected, atividade.id) > -1 : (_vm.activitiesSelected)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.activitiesSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = atividade.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.activitiesSelected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.activitiesSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.activitiesSelected = $$c
          }
        }, function($event) {
          _vm.handleActivityCheck(atividade)
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'atividade-' + atividade.id
      }
    }, [_vm._v("\n                    " + _vm._s(atividade.nome) + "\n                    "), (atividade.using_new_certificado && atividade.certificado != _vm.certificadoDados.id) ? _c('small', [_c('br'), _vm._v("(Utilizando o certificado "), _c('strong', [_vm._v("'" + _vm._s(atividade.certificado_nome) + "'")]), _vm._v(")")]) : _vm._e()])])
  }), _vm._v(" "), (_vm.activitiesOptions.length === 0) ? _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n                  Seu evento ainda não possui nenhuma atividade cadastrada. Clique "), _c('a', {
    attrs: {
      "href": _vm.url + 'admin/inscricao/atividades',
      "target": "_blank"
    }
  }, [_vm._v("aqui")]), _vm._v(" para cadastrar uma nova\n                ")]) : _vm._e()], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-buttons"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('h5', [_vm._v("Informe o ID do congressista de exemplo (ou deixe em branco): "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.id_exemplo),
      expression: "id_exemplo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "ID Aleatório"
    },
    domProps: {
      "value": (_vm.id_exemplo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.id_exemplo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('input', {
    staticClass: "vp-btn vp-btn vp-edit-btn btn btn-lg",
    attrs: {
      "type": "submit",
      "value": "Salvar"
    }
  }), _vm._v(" "), (_vm.id != 0) ? _c('a', {
    staticClass: "btn vp-btn vp-action-btn btn-lg",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.baixarCertificado()
      }
    }
  }, [_vm._v("Exemplo")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn vp-ghost-btn vp-back-btn btn-lg",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Voltar")])], 1)])])])])]) : _vm._e(), _vm._v(" "), _c('vodal', {
    staticClass: "vodal-middle",
    attrs: {
      "show": _vm.showNewModelModal,
      "animation": "flip"
    },
    on: {
      "hide": function($event) {
        _vm.showNewModelModal = false
      }
    }
  }, [_c('div', {
    staticClass: "vodal-content"
  }, [_c('div', {
    staticClass: "vodal-heading"
  }, [_c('h4', {
    staticClass: "vp-h4"
  }, [_vm._v("\n          Adicionar novo modelo de certificado\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "vodal-middle"
  }, [_c('div', {
    staticClass: "form-group row-flex"
  }, [_c('label', {
    staticClass: "col-12 control-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v("\n            Escolha um nome para o modelo:\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newModelData.nome),
      expression: "newModelData.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": 'campo_' + _vm.certificadoDados.id,
      "placeholder": "Escolha um nome para identificar o certificado"
    },
    domProps: {
      "value": (_vm.newModelData.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newModelData, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row-flex"
  }, [_c('label', {
    staticClass: "col-12 control-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v("\n            Imagem do modelo:\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "new-model-input"
    },
    on: {
      "change": _vm.modelImageChanged
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "vp-btn btn btn-md",
    on: {
      "click": function($event) {
        _vm.createNewModel()
      }
    }
  }, [_vm._v("Criar")])]), _vm._v(" "), _c('div', {
    staticClass: "vodal-footer"
  }, [_c('a', {
    staticClass: "vp-btn vp-flat-btn vp-edit-btn btn btn-md ",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showNewModelModal = false
      }
    }
  }, [_vm._v("Fechar")])])])]), _vm._v(" "), _c('vodal', {
    staticClass: "vodal-middle",
    attrs: {
      "show": _vm.showNewSignatureModal,
      "animation": "flip"
    },
    on: {
      "hide": function($event) {
        _vm.showNewSignatureModal = false
      }
    }
  }, [_c('div', {
    staticClass: "vodal-content"
  }, [_c('div', {
    staticClass: "vodal-heading"
  }, [_c('h4', {
    staticClass: "vp-h4"
  }, [_vm._v("\n          Adicionar nova assinatura\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "vodal-middle"
  }, [_c('div', {
    staticClass: "form-group row-flex"
  }, [_c('label', {
    staticClass: "col-12 control-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v("\n            Insira o nome completo do autor da assinatura:\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSignatureData.nome),
      expression: "newSignatureData.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": 'campo_' + _vm.certificadoDados.id,
      "placeholder": "Nome do autor da assinatura"
    },
    domProps: {
      "value": (_vm.newSignatureData.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newSignatureData, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row-flex"
  }, [_c('label', {
    staticClass: "col-12 control-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v("\n            Imagem com a assinatura:\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "new-sign-input"
    },
    on: {
      "change": _vm.signatureImageChanged
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "vp-btn btn btn-md",
    on: {
      "click": function($event) {
        _vm.createNewSignature()
      }
    }
  }, [_vm._v("Criar")])]), _vm._v(" "), _c('div', {
    staticClass: "vodal-footer"
  }, [_c('a', {
    staticClass: "vp-btn vp-flat-btn vp-edit-btn btn btn-md ",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showNewSignatureModal = false
      }
    }
  }, [_vm._v("Fechar")])])])]), _vm._v(" "), _c('vodal', {
    staticClass: "vodal-middle preview-vodal",
    class: _vm.certificadoDados.configs.formato,
    attrs: {
      "show": _vm.showPreviewModal,
      "animation": "flip"
    },
    on: {
      "hide": function($event) {
        _vm.showPreviewModal = false
      }
    }
  }, [_c('div', {
    staticClass: "vodal-content"
  }, [_c('div', {
    staticClass: "vodal-heading"
  }, [_c('h4', {
    staticClass: "vp-h4"
  }, [_vm._v("\n          Exemplo\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "vodal-middle"
  }, [_c('object', {
    attrs: {
      "data": _vm.demoUrl,
      "type": "application/pdf",
      "width": _vm.canvasWidth,
      "height": _vm.canvasHeight
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.demoUrl
    }
  }, [_vm._v(_vm._s(_vm.demoUrl))])])]), _vm._v(" "), _c('div', {
    staticClass: "vodal-footer"
  }, [_c('a', {
    staticClass: "vp-btn vp-flat-btn vp-edit-btn btn btn-md ",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showPreviewModal = false
      }
    }
  }, [_vm._v("Fechar")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-12 control-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v("\n            Nome:\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("Insira os seguintes atalhos no certificado para adicionar dados específicos de cada participante em seu respectivo certificado"), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vp-ft-heading"
  }, [_c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      Atalho"), _c('br'), _c('small', [_vm._v("Relacionado ao evento")])]), _vm._v(" "), _c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      Descrição\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vp-ft-row"
  }, [_c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      {nome}\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      Nome do participante\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vp-ft-row"
  }, [_c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      {categoria}\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      Categoria em que o participante está inscrito\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vp-ft-row"
  }, [_c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      {nome evento}\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      O nome do evento\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vp-ft-row"
  }, [_c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      {data inicio}\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      Data de início do evento\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vp-ft-row"
  }, [_c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      {data termino}\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      Data de término do evento\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vp-ft-heading"
  }, [_c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      Atalho"), _c('br'), _c('small', [_vm._v("Relacionado às atividades")])]), _vm._v(" "), _c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      Descrição\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vp-ft-row"
  }, [_c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      {total minutos}\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      Os minutos do participante em todas as atividades\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vp-ft-row"
  }, [_c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      {total horas}\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      As horas do participante em todas as atividades\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vp-ft-heading"
  }, [_c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      Atalho"), _c('br'), _c('small', [_vm._v("Relacionado ao trabalho")])]), _vm._v(" "), _c('div', {
    staticClass: "vp-ft-col"
  }, [_vm._v("\n                      Descrição\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "fa-stack fa-lg"
  }, [_c('i', {
    staticClass: "fa fa-stack-2x fa-square"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-stack-1x fa-inverse fa-image"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "fa-stack fa-lg"
  }, [_c('i', {
    staticClass: "fa fa-stack-2x fa-square"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-stack-1x fa-inverse fa-undo"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('p', {
    staticClass: "warning-message"
  }, [_c('strong', [_vm._v("Por exemplo:")]), _vm._v(" o participante deverá ter assistido no mínimo 2 horas de atividades (120 minutos) para retirar o certificado.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-363b6c72","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CertificadoEditor.vue
// module id = 208
// module chunks = 2